import AoneService from "../axiosbase";

//template for multiple employees with areas
export const multiAreasTemplate = async () => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/areas/bulk/template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//import multiple employees with areas
export const multiAreassimport = async (data) => {
  try {
    return await AoneService.post(`employees/api/v1/employees/areas/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
//template for multiple employees with attributes
export const multiAttributesTemplate = async () => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/attributes/template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//import multiple employees with attributes
export const multiAttributesimport = async (data) => {
  try {
    return await AoneService.post(`employees/api/v1/employees/attributes/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
//get Payroll
export const getPayroll = async (params) => {
    try {
      return await AoneService.get(`employees/api/v1/companies${params}`);
    } catch (error) {
      return error;
    }
  };
//post Payroll
export const postPayroll = async (data) => {
    try {
      return await AoneService.post("employees/api/v1/companies", data);
    } catch (error) {
      return error;
    }
  };
//edit Payroll
export const editPayroll = async (params,data) => {
    try {
      return await AoneService.put(`employees/api/v1/companies/${params}`, data);
    } catch (error) {
      return error;
    }
  };
//template for Payroll
export const payrollTemplate = async () => {
  try {
    return await AoneService.get(
      `employees/api/v1/companies/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//upload Payroll
export const importPayroll = async (data) => {
    try {
      return await AoneService.post(`employees/api/v1/companies/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
//export Payroll
export const exportPayroll = async (params) => {
    try {
      return await AoneService.get(`employees/api/v1/companies/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//delete Payroll
export const deletePayroll = async (params) => {
    try {
      return await AoneService.delete(`employees/api/v1/companies/${params}`);
    } catch (error) {
      return error;
    }
  };
  //Payroll lookups
  export const getCompanyStatus = async () => {
    try {
      return await AoneService.get(`employees/api/v1/lookups/CompanyStatus`);
    } catch (error) {
      return error;
    }
  };
  export const getCompanyType = async () => {
    try {
      return await AoneService.get(`employees/api/v1/lookups/CompanyType`);
    } catch (error) {
      return error;
    }
  };
  export const getCompanyCategory = async () => {
   try {
     return await AoneService.get(`employees/api/v1/lookups/CompanyCategory`);
   } catch (error) {
     return error;
   }
 };

 //crowdsource/outsource
 //get employees
export const getEmployee = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1//os-cs" + params
    );
  } catch (error) {
    return error;
  }
};
//filter employee
export const filterEmployee = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/filter" + params
    );
  } catch (error) {
    return error;
  }
};
//get employeebyid
export const getEmployeebyId = async (params) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/${params}`
    );
  } catch (error) {
    return error;
  }
};
//post employees
export const postEmployee = async (data) => {
  try {
    return await AoneService.post("employees/api/v1//os-cs", data);
  } catch (error) {
    return error;
  }
};
//edit employees
export const editEmployees = async (params, data) => {
  try {
    return await AoneService.put(
      `employees/api/v1/os-cs/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};
//get employee field name
export const getFieldName = async (params, data) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/${params}/view/${data}`
    );
  } catch (error) {
    return error;
  }
};
//delete employees
export const deleteEmployees = async (params) => {
  try {
    return await AoneService.delete(
      "employees/api/v1/employees/" + params
    );
  } catch (error) {
    return error;
  }
};
//export employees
export const exportEmployee = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1//os-cs/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//employee template
export const getEmployeesTemplate = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1//os-cs/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//employee import
export const importEmployees = async (data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/os-cs/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
//areas
//get areas
export const getAreas = async (params, params1) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/${params}/areas` + params1
    );
  } catch (error) {
    return error;
  }
};
//post areas
export const postAreas = async (params, data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/employees/${params}/areas`,
      data
    );
  } catch (error) {
    return error;
  }
};
//edit areas
export const editAreas = async (params, params2, data) => {
  try {
    return await AoneService.patch(
      `employees/api/v1/employees/${params}/areas/${params2}`,
      data
    );
  } catch (error) {
    return error;
  }
};
//delete areas
export const deleteAreas = async (params) => {
  try {
    return await AoneService.delete(
      "employees/api/v1/employees/areas/" + params
    );
  } catch (error) {
    return error;
  }
};
//export areas
export const exportAreas = async (params1, params) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/${params1}/areas/export` + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//areas template
export const getAreasTemplate = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/areas/template",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//areas import
export const importAreas = async (params, data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/employees/${params}/areas/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
//login-information
export const postLoginInfoemployee = async (params,data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/employees/${params}/user-management`,
      data
    );
  } catch (error) {
    return error;
  }
};
//save attributes
export const postAttributes = async (data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/employees/attributes`,
      data
    );
  } catch (error) {
    return error;
  }
};
//reset password
export const resetPasswordEmployee = async (data) => {
  try {
    return await AoneService.post(
      "employees/api/v1/employees/user-management/reset-password",
      data
    );
  } catch (error) {
    return error;
  }
};
//toggle user status
export const toggleUserstatus = async (param1, param2) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/user-management/toggle-user-status/${param1}/${param2}`
    );
  } catch (error) {
    return error;
  }
};
//generate password
export const generatePassword = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/user-management/generate-password"
    );
  } catch (error) {
    return error;
  }
};
//get employee jobtitle
//generate password
export const getEmployeeJobtitle = async (params) => {
  try {
    return await AoneService.get(
      `employees/api/v1/employees/${params}/profile`
    );
  } catch (error) {
    return error;
  }
};

//OSCS Nationality
export const verifyEmployeeNationality = async (params, data) => {
  try {
    return await AoneService.put(
      `employees/api/v1/os-cs/${params}/verify`,
      data
    );
  } catch (error) {
    return error;
  }
};
//upload document
  export const importEmployeeDocument = async (params,data) => {
    try {
      return await AoneService.post(`employees/api/v1/os-cs/${params}/document`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  //pending verifications
  export const getPendingVerifications = async (params) => {
  try {
    return await AoneService.get(
      `employees/api/v1/os-cs/pending${params}`
    );
  } catch (error) {
    return error;
  }
};

//Lookups-jobtitle
export const employeeJobtitle = async () => {
  try {
    return await AoneService.get("employees/api/v1/lookups/JobTitle");
  } catch (error) {
    return error;
  }
};

//department
export const employeedepartment = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/Department"
    );
  } catch (error) {
    return error;
  }
};

//payrolltype
export const employeePayrolltype = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/PayrollType"
    );
  } catch (error) {
    return error;
  }
};

//Nationality
export const employeeNationality = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/Nationality"
    );
  } catch (error) {
    return error;
  }
};

//payroll company
export const employeePayrollCompany = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/PayrollCompany"
    );
  } catch (error) {
    return error;
  }
};

//legacy system
export const employeeLegacySystem = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/LegacySystem"
    );
  } catch (error) {
    return error;
  }
};

export const employeeDepartments = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/departments"
    );
  } catch (error) {
    return error;
  }
};

export const getJobtitlebyDept = async (params) => {
  try {
    return await AoneService.get(
      `employees/api/v1/lookups/department/${params}`
    );
  } catch (error) {
    return error;
  }
};

export const getEmployeeDepartments = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/lookups/departments"
    );
  } catch (error) {
    return error;
  }
};

export const postEmployees = async (data) => {
  try {
    return await AoneService.post("employees/api/v1/employees", data);
  } catch (error) {
    return error;
  }
};

export const getEmployees = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees" + params
    );
  } catch (error) {
    return error;
  }
};

export const getEmployeeById = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/" + params
    );
  } catch (error) {
    return error;
  }
};

export const putEmployeeById = async (params, data) => {
  try {
    return await AoneService.put(
      "employees/api/v1/employees/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

export const exportEmployees = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
